


const DIGITAL_CURRENCY_ACCOUNT_INDEX_ID = 'digital-currency-account'


export {
  DIGITAL_CURRENCY_ACCOUNT_INDEX_ID
}




